import { makeStyles } from 'e100-react-components';

const useGlobalStyles = makeStyles(() => ({
  '@global': {
    '#map': {
      cursor: 'grab',
      '& > div': {
        cursor: 'unset !important'
      },
    },
    '#deckgl-overlay': {
      top: 0,
      left: 0,
      pointerEvents: 'none',
      touchAction: 'none'
    }
  }
}));

export default useGlobalStyles;
